/**
 * 页面状态持久化
 * 
 * @author 张子超
 * @since 2018-08-16
 */
import $ from "jquery";

var PageState = {};

var defaultUIData = ()=>{
    return {
        scrollTop: $(window).scrollTop()
    };
}

/**
 * 启动监听，当Component.keepAlive = true时启用
 * @param {*} $root App对象
 */
PageState.start = function($root){
    var timer;

    window.addEventListener("scroll",()=>{
      //延时保存
      clearTimeout(timer);
      timer = setTimeout(()=>{
        //获取当前的组件
        var component = $root.$route.matched["0"].components.default;
        if(component.keepAlive){
            //保存当前组件的数据
            PageState.save($root.$root.$children["0"].$children["0"]);
        }
      }, 300);
    });
}

/**
 * 保存当前组件的数据
 * @param {*} vueObj 
 */
PageState.save = function(vueObj){
    var key = 'PS:'+location.pathname+location.search;
    var state = {
        //页面数据
        PageData: vueObj.$data,
        //UI数据
        UIData: defaultUIData()
    };
    try{
        sessionStorage.setItem(key, JSON.stringify(state));
    }catch(e){
        console.error(e);
    }
}

PageState.recover = function(vueObj, initCb = ()=>{}, recoverCb = ()=>{}){
    var key = 'PS:'+location.pathname+location.search;
    try{
        var dataStr = sessionStorage.getItem(key);
        
        if(!dataStr){
            console.log('无法获取恢复数据');
            initCb();
            return;
        }
        console.log('恢复数据');
        var state = JSON.parse(dataStr);
        console.log(state);
        for(var i in state.PageData){
            console.log('恢复:'+i+'='+state.PageData[i]);
            vueObj[i] = state.PageData[i];
        }

        var scrollTop = state.UIData.scrollTop;
        if(scrollTop){
            
            setTimeout(()=>{
                console.log('滚动：'+scrollTop);
                $(window).scrollTop(scrollTop);
            }, 10);
            
        }
        //清除状态
        PageState.clear();
        //回调恢复完成
        recoverCb();
    }catch(e){
        console.error(e);
        //回调恢复完成
        initCb();
    }
}

PageState.clear = function(){
    sessionStorage.clear();
}

export default PageState;


// WEBPACK FOOTER //
// ./src/api/pagestate.js